import { render, staticRenderFns } from "./SocietyPage.vue?vue&type=template&id=27ddb562&scoped=true&"
import script from "./SocietyPage.vue?vue&type=script&lang=js&"
export * from "./SocietyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddb562",
  null
  
)

export default component.exports